import { useEffect, useState, useRef } from "react";
import { Tooltip } from "antd";
import { handlePdfDocument } from "../../function.js";
import { PDFDownloadLink } from "@react-pdf/renderer";
import pdfDimensions from "./pdfDimensions.js";

const SelectResult = (props) => {
  const {
    handleApply,
    applyState,
    englishTextValue,
    arabicTextValue,
    resultArabDescription,
    resultEngDescription,
    resultImage,
    resultId,
    pdfId,
    previewImage,
  } = props;
  const [result, setResult] = useState();
  const [document, setDocument] = useState();
  const [pdfTitle, setPdfTitle] = useState();
  const [engChunks, setEngChunks] = useState([]);
  const [arabChunks, setArabChunks] = useState([]);
  const [resultPdfId, setResultPdfId] = useState();
  const [resultsFilters, setResultsFilters] = useState();

  const canvasRef = useRef(null);

  const splitText = () => {
    let englishText = englishTextValue;
    let arabicText = arabicTextValue;

    const engVerticalCount = pdfDimensions[pdfId].english.count;
    const engHorizontalWidth = pdfDimensions[pdfId].english.width;
    const arabVerticalCount = pdfDimensions[pdfId].arabic.count;
    const arabHorizontalWidth = pdfDimensions[pdfId].arabic.width;

    let englishTextChunks = splitLines(
      englishText,
      engHorizontalWidth,
      engVerticalCount,
      true
    );
    let arabicTextChunks = splitLines(
      arabicText,
      arabHorizontalWidth,
      arabVerticalCount,
      false
    );

    setEngChunks(englishTextChunks);
    setArabChunks(arabicTextChunks);
  };

  const splitLines = (text, horizontalWidth, verticalCount, ifJoin) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    text = text.match(/(\S+)/g);

    context.font = `300 9px IBM Plex Sans Arabic`;

    let lines = [];
    let paragraphs = [];
    let start = 0;
    let end = text.length;

    // until we get an octave of verticalCount lines
    for (let i = 1; i <= verticalCount * 8; i++) {
      start = 0;
      end = text.length;

      while (start < end) {
        const middle = Math.floor((start + end) / 2);
        const slicedText = text.slice(0, middle + 1);

        const textWidth = context.measureText(slicedText.join(" ")).width;

        if (textWidth <= horizontalWidth) {
          start = middle + 1;
        } else {
          end = middle;
        }
      }

      ifJoin
        ? lines.push(text.slice(0, start).join(" "))
        : lines.push(text.slice(0, start));

      if (i % verticalCount === 0) {
        paragraphs.push(lines);
        lines = [];
      }
      text = text.slice(start);
    }

    return paragraphs;
  };

  const handlePdfTitle = () => {
    if (pdfId > 0 && pdfId <= 6) {
      setPdfTitle(`RL-0${pdfId}`);
    } else if (pdfId > 6 && pdfId <= 12) {
      setPdfTitle(`LR-0${pdfId - 6}`);
    } else if (pdfId > 12 && pdfId <= 25) {
      setPdfTitle(`RLLR-0${pdfId - 12}`);
    } else {
      setPdfTitle(`Vertical-0${pdfId - 25}`);
    }
  };

  useEffect(() => {
    setResultPdfId(pdfId);
    splitText();
  }, [englishTextValue, arabicTextValue]);

  useEffect(() => {
    setResult(handlePdfDocument(arabChunks, engChunks, resultPdfId));
    handlePdfTitle();
  }, [resultPdfId]);

  useEffect(() => {
    if (result) {
      setDocument(result[0]);
      setResultsFilters(result[1]);
    }
  }, [result]);

  return (
    <div className="select-result">
      <div
        className="select-result-back"
        onClick={() => {
          handleApply(!applyState);
        }}
      >
        <canvas
          id="canvas"
          width="100px"
          height="100px"
          ref={canvasRef}
          style={{ display: "none" }}
        />
        <img src="/icons/red_arrow_back.svg" alt="Back" />
        <div className="select-result-back-text">
          <span className="select-result-back-text-eng">
            back to structures •
          </span>
          <span className="select-result-back-text-arab">
            {" "}
            عودة إلى الهياكل
          </span>
        </div>
      </div>
      <hr />
      <div className="select-result-top">
        <div style={{ display: "flex", margin: "2% 0 2% 0" }}>
          <span className="select-result-top-number">{resultId}</span>
          <div style={{ width: "90%" }}>{resultImage}</div>
        </div>
        <div className="select-result-top-title">
          <span className="select-result-top-title-eng">preview</span>
          <span className="select-result-top-title-arab"> معاينة</span>
        </div>
        <div
          className="select-result-top-preview"
          style={{ justifyContent: resultPdfId > 25 && "center" }}
        >
          <img
            src={previewImage}
            style={{
              width:
                resultPdfId === 26 ||
                resultPdfId === 27 ||
                resultPdfId === 33 ||
                resultPdfId === 34
                  ? "50%"
                  : "100%",
            }}
            alt="PreviewImage"
          ></img>
        </div>
      </div>
      <div className="select-result-text">
        <p className="select-result-text-english">{resultEngDescription}</p>
        <p className="select-result-text-arabic">{resultArabDescription}</p>
      </div>
      <div className="select-result-down">
        <div className="select-result-icons">
          {resultsFilters?.map((filterIcon, index) => {
            return (
              <>
                <Tooltip
                  placement="top"
                  title={`${filterIcon.arabTitle}  ${filterIcon.engTitle}`}
                  overlayClassName="select-result-tooltip"
                  showArrow={false}
                  key={index}
                >
                  <img
                    src={filterIcon.icon}
                    className="select-result-icons-icon"
                    alt="FilterIcon"
                  />
                </Tooltip>
              </>
            );
          })}
        </div>
        <PDFDownloadLink document={document} fileName={pdfTitle}>
          {({ loading }) =>
            loading ? (
              <div>Loading! Please wait...</div>
            ) : (
              <img
                src="/icons/download_pdf.svg"
                alt="Download Button"
                style={{ width: "155px", height: "54px" }}
              ></img>
            )
          }
        </PDFDownloadLink>
      </div>
    </div>
  );
};

export default SelectResult;
